import React, { Component } from "react";

import "./index.css";

class NotFoundPage extends Component {
  render() {
    return (
      <div className="notfound-message-container">
        <h1>404 - Page Not Found</h1>
        <p>Sorry, it looks like the page you were looking for doesn't exist.</p>
        <p>
          If you require immediate assistance, please feel free to contact the
          development team at{" "}
          <a href="mailto:cypinfrastructure@wspdigital.com">
            cypinfrastructure@wspdigital.com
          </a>.
        </p>
        <hr />
        <p>
          <a class="btn btn-default" href="/">
            Home
          </a>
        </p>
      </div>
    );
  }
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/_components/NotFoundPage/index.js